// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ai-prohibited-practices-screening.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ai-prohibited-practices-screening',
  title: 'Screen AI systems against prohibited AI practices',
  description:
    'Confirm that every AI system in scope is screened against the EU AI Act Art. 5 list of prohibited practices — manipulative techniques, exploitation of vulnerabilities, social scoring, unfocused scraping of facial images, emotion recognition in workplaces and schools, biometric categorisation of sensitive characteristics, real-time remote biometric identification in public spaces — prior to design, acquisition, deployment or significant change, and that prohibited practices are not placed on the market, put into service or used. Review the prohibited-practices screening procedure and the log of screening outcomes.',
  category: 'compliance',
  scfIds: ['SCF-AIG-013'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    {
      type: 'document-published',
      description: 'Prohibited-practices screening procedure is published',
    },
    { type: 'document-approved', description: 'Procedure has been approved' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
